module.exports = __webpack_public_path__ + "img/solution-cokpit03-system-pic.3d0f9202.png";